import { propNameSelector } from '../utils';
import { statisticsSelector } from './root';

export const statisticsRefferersSelector = propNameSelector(statisticsSelector, 'refferers');
export const statisticsPopGoodsSelector = propNameSelector(statisticsSelector, 'popGoods');
export const statisticsOrderGoodsSelector = propNameSelector(statisticsSelector, 'orderGoods');
export const statisticsOrdersSelector = propNameSelector(statisticsSelector, 'orders');
export const statisticsPromocodeSelector = propNameSelector(statisticsSelector, 'promocode');
export const statisticsClientsSelector = propNameSelector(statisticsSelector, 'clients');
export const statisticsPointslogsSelector = propNameSelector(statisticsSelector, 'pointslogs');